/**
 * CRO Select Plan - Scroll Reveal Animation
 * Uses IntersectionObserver for performant scroll-triggered animations
 */
(function() {
  const elements = document.querySelectorAll('.cro-select-plan [data-reveal]');

  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }
  );

  elements.forEach((el) => observer.observe(el));
})();
